import PropTypes from "prop-types";
import FileUpload from "../../../../components/Shared/FileUpload";

const AddRegistrationPDF = ({ setRegistrationPDF, selectedFile, t }) => (
    <div>
        <p className="text-md font-medium mb-2">{t("uploadRegistrationPDF")}</p>
        <FileUpload onFileSelect={setRegistrationPDF} selectedFile={selectedFile} />
    </div>
);

AddRegistrationPDF.propTypes = {
    setRegistrationPDF: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    selectedFile: PropTypes.object,
};

export default AddRegistrationPDF;
